import {
	Badge,
	CircularProgress,
	ClickAwayListener,
	Grid,
	Paper,
  } from "@material-ui/core";
  import { makeStyles, withStyles } from "@material-ui/core/styles";
  import React from "react";
  import { Bell } from "react-feather";
  import { TEXT_SECONDARY_COLOR } from "../../theme";
  const NotificacoesCabecalho = props => {
	const classes = useStyles(props);
	const {
	  children,
	  haNotificacoes,
	  handleClickAway,
	  handleClick,
	  open,
	  carregando,
	} = props;
	return (
	  <ClickAwayListener onClickAway={handleClickAway}>
		<div className={classes.root}>
		  {carregando ? (
			<Grid
			  container
			  alignItems="center"
			  justifyContent="center"
			  spacing={2}
			  className={classes.botao}
			>
			  <Grid item>
				<CircularProgress size={20} />
			  </Grid>
			</Grid>
		  ) : (
			<Grid
			  onClick={handleClick}
			  container
			  alignItems="center"
			  justifyContent="center"
			  className={[classes.botao, classes.cursor].join(" ")}
			  spacing={2}
			>
			  <Grid item>
				<StyledBadge
				  id="bola-notificacoes"
				  variant="dot"
				  invisible={!haNotificacoes}
				>
				  <Bell color={TEXT_SECONDARY_COLOR} size={20} />
				</StyledBadge>
			  </Grid>
			</Grid>
		  )}
		  {open && children && (
			<React.Fragment>
			  <Paper
				className={[classes.paper, classes.paperDefaultStyle].join(" ")}
			  >
				<Grid container>{children}</Grid>
			  </Paper>
			  <div className={classes.barraInferior} />
			</React.Fragment>
		  )}
		</div>
	  </ClickAwayListener>
	);
  };
  const useStyles = makeStyles({
	root: {
	  height: "100%",
	},
	barraInferior: {
	  height: "2px",
	  width: "calc(100% + 14px)",
	  backgroundColor: "#BF43AB",
	  transform: "translate(-7px, 25px)",
	},
	botao: {
	  height: "100%",
	  paddingTop: "10px",
	},
	cursor: {
	  cursor: "pointer",
	},
	content: {
	  height: "300px",
	},
	paper: {
	  boxShadow: "-4px 11px 17px -6px rgba(0,0,0,0.15)",
	  maxHeight: "75vh",
	  position: "absolute",
	  overflowY: "auto",
	  maxWidth: "400px",
	  minWidth: "20%",
	  paddingBottom: "9px",
	},
	paperDefaultStyle: {
	  transform: "translate(-8px, 28px)",
	},
	paperMobileStyle: {
	  transform: "translateY(28px)",
	  maxWidth: "100%",
	  right: "0px",
	},
  });
  const StyledBadge = withStyles({
	badge: {
	  right: "5px",
	  top: "5px",
	  backgroundColor: "#BF43AB",
	  height: "7px",
	  minWidth: "7px",
	},
  })(Badge);
  export default NotificacoesCabecalho;